import { useAction } from "convex/react";

import { Button } from "@/components/ui/button";
import { useReviewTime } from "@/hooks/useReviewTime";
import { api } from "@convex/_generated/api";

interface SendTestNotificationButtonProps {
  currentSubscription: PushSubscription;
}

export const SendTestNotificationButton = ({
  currentSubscription,
}: SendTestNotificationButtonProps) => {
  const reviewTime = useReviewTime();
  const sendTestNotification = useAction(api.notifications.sendTestNotification);
  const handleSendTestNotificationClick = async () => {
    await sendTestNotification({
      pushSubscription: JSON.stringify(currentSubscription),
      reviewTime,
    });
  };

  return (
    <Button variant="outline" onClick={handleSendTestNotificationClick}>
      Send test notification
    </Button>
  );
};
